import React, {CSSProperties, useContext} from "react";
import {TCouponItem} from "@/page-components/detail/Intro/Coupon/couponItem";
import {PayState} from "@/page-components/detail/Intro/exam_plan";
import {DetailContext} from "@/context/detailContext";
import PCSignupBtnP from "@/page-components/detail/Intro/pc_signup_btn_p";
import PCSignupBtnA from "@/page-components/detail/Intro/pc_signup_btn_a";
import {judgeIsPExam} from "@/utils/index";

type TSignupBtn = {
  passExam?: boolean;
  noPass?: boolean; // 是否处于没通过的状态下
  payState?: PayState;
  className?: string;
  wrapperName?: string;
  wrapperStyle?: CSSProperties;
  coupons?: TCouponItem[];
  shouldPassOpt?: {
    id: string,
    isPass?: boolean;
    label: string;
    value: string;
    price: number;
    student_price?: number
  }[];
}

const PCSignupBtn: React.FC<TSignupBtn> = (
  {
    passExam = false,// 是否通过了考试
    noPass = false,
    payState,
    className,
    wrapperName,
    wrapperStyle,
    children
  }) => {
  // 从context继承
  const contextProps = useContext(DetailContext);
  const {data: {type}} = contextProps;
  // 报名P系列考试
  return (
    <div className={wrapperName} style={wrapperStyle}>
      {
        judgeIsPExam(type) ?
          <PCSignupBtnP
            isPassExam={passExam}
            childrenComponent={children}
            isExamed={noPass}
            className={className}
            payState={payState}
          /> :
          <PCSignupBtnA
            childrenComponent={children}
            noPass={noPass}
            className={className}
          />}
    </div>
  )
}
export default PCSignupBtn;
